import React from 'react';
import classes from './ControlsToggle.css';
import menuButton from '../../img/menuButton.svg';

const controlsToggle = (props) => (
    <button className={classes.js_togggleControls} style={{backgroundImage: `url(${menuButton})`}} onClick={props.click}></button>
)
export default controlsToggle;


// WEBPACK FOOTER //
// ./src/components/ControlsToggle/ControlsToggle.js